export const emailRegex = new RegExp(
  /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,7}))$/,
);
export const passwordRegex = new RegExp(
  /(^(?=.*\d)(?=.*[A-Za-z])|^(?=.*[!@#$%^&*])(?=.*[A-Za-z])|^(?=.*[!@#$%^&*])(?=.*\d))[\da-zA-Z!@#$%^&*]{6,20}$/,
);

export const corporateRegistrationNumberRegex = new RegExp(
  /^(\d{3,3})+[-]+(\d{2,2})+[-]+(\d{5,5})$/,
);
export const phoneRegex = new RegExp(/^(\d{2,3})-(\d{3,4})-(\d{3,4})$/);
export const nameRegex = new RegExp(/^[가-힣a-zA-Z]+$/);

export const emailFrontRegex = new RegExp(/^[\w]+$/);

export const onlyNumberRegExp = /[^0-9]/g;
/** 010 1234 1234 */
export const phoneNumberFormatRegExp = /^(\d{0,3})(\d{0,4})(\d{0,4})$/g;
/** '--' > '' */
export const deleteStartHypenRegExp = /(-{1,2})$/g;
